var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center page-height"},[_c('h1',{staticClass:"text-center"},[_c('strong',{staticClass:"red--text text--lighten-1"},[_vm._v("Blimey! Page not found!")])])])
}]

export { render, staticRenderFns }